<template>
  <div style="width: 100%;height: 100%;overflow: auto">
    <div style="display: flex;margin-top: 10px">
      <el-select v-model="year" style="width: 150px;height: 35px;margin-left: 10px" @change="init">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="team" style="width: 200px;margin-left: 10px" @change="init">
        <el-option v-for="item in teamList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <div class="dimension_amount" :style="salesStyle" @click="getDimensionSalesInfo()">
        销量(套)
      </div>
      <div class="dimension_sales" :style="mountStyle" @click="getDimensionMountInfo()">
        金额(￥)
      </div>
    </div>

    <div style="width: 100%;margin-top: 10px" v-for="(item,index) in kpiNameList">
      <div style="margin-top: 10px;font-size: 16px;"><b>{{ index + 1 }}. {{ item.kpiName }}：</b></div>
      <div style="display: flex;width: 100%;height: 400px;margin-top: 20px">
        <div style="width: 49%;height: 400px" :id="'monthChart-' + index"/>
        <div style="width: 49%;height: 400px" :id="'accrueChart-' + index"/>
      </div>
    </div>


  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';

dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);

export default {
  name: "MonthKpi",


  data() {
    return {
      year: '',
      team:'',
      showDollar:true,
      teamList:[],
      yearList: [],
      kpiNameList:[

      ],
      salesStyle:'',
      mountStyle:''
    }
  },
  // async mounted(){
  //   await this.renderEcharts();
  // },


  async created() {
    await this.getYearList();
    await this.getAllTeam();
    await this.getDimensionMountInfo();

    await this.init();

  },

  methods:{

    async getAllTeam(){
      this.teamList = await this.$http('crmTeamService.getTeamByRole');
      if(this.teamList){
        this.team = this.teamList[0].value;
      }
    },

    async getYearList(){
      const now = dayjs();
      this.year = now.year() + '';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },
    async getDimensionSalesInfo(){
      //先改渲染状态
      if(this.mountStyle){
        this.mountStyle = '';
      }
      this.salesStyle = 'background: rgb(4,134,254);color:white';

      this.showDollar = false;

      await this.renderEcharts();

    },
    async getDimensionMountInfo(){
      //先改渲染状态
      if(this.salesStyle){
        this.salesStyle = '';
      }
      this.mountStyle = 'background: rgb(4,134,254);color:white';

      this.showDollar = true;

      await this.renderEcharts();

    },
    async init(){
      await this.getKpiData();
      await this.renderEcharts();
    },

    async getKpiData(){
      let params = {year:this.year,team:this.team}
      this.kpiNameList = await this.$http('crmTeamService.getMonthKpiData', params);
    },

    async renderEcharts() {
      for(let data of this.kpiNameList){
        let idx = this.kpiNameList.findIndex(item=>item.kpiName === data.kpiName);

        //计算显示金额还是套装逻辑
        let monthlyData = data.monthlyData;
        let monthData = {};
        let accrueData = {};
        if(this.showDollar){
          monthData.yName = monthlyData.yName2;
          accrueData.yName = monthlyData.yName2;
          if(monthlyData.data){
            let data = [];
            let accrueDatas = [];
            for (let item of monthlyData.data){
              let dataItem = {};
              dataItem.name = item.name;
              dataItem.type = item.type;
              dataItem.data = item.dataAmount;
              data.push(dataItem);
              let accrueDataItem = {};
              accrueDataItem.name = item.name;
              accrueDataItem.type = item.type;
              accrueDataItem.data = item.dataAmountAccrue;
              accrueDatas.push(accrueDataItem);
            }
            monthData.seriesData = data;
            accrueData.seriesData = accrueDatas;
          }
        }else {
          monthData.yName = monthlyData.yName1;
          accrueData.yName = monthlyData.yName1;
          if(monthlyData.data){
            let data = [];
            let accrueDatas = [];
            for (let item of monthlyData.data){
              let dataItem = {};
              dataItem.name = item.name;
              dataItem.type = item.type;
              dataItem.data = item.dataCnt;
              data.push(dataItem);
              let accrueDataItem = {};
              accrueDataItem.name = item.name;
              accrueDataItem.type = item.type;
              accrueDataItem.data = item.dataCntAccrue;
              accrueDatas.push(accrueDataItem);
            }
            monthData.seriesData = data;
            accrueData.seriesData = accrueDatas;
          }
        }

        const monthChartDom = document.getElementById('monthChart-' + idx);
        const accrueChartDom = document.getElementById('accrueChart-' + idx);

        // 获取现有的 ECharts 实例（如果有）
        let myMonthChart = echarts.getInstanceByDom(monthChartDom);
        let myAccrueChart = echarts.getInstanceByDom(accrueChartDom);

        // 如果存在现有的实例，销毁它
        if (myMonthChart) {
          myMonthChart.dispose();
        }

        // 如果存在现有的实例，销毁它
        if (myAccrueChart) {
          myAccrueChart.dispose();
        }

        // 初始化新的 ECharts 实例
        myMonthChart = echarts.init(monthChartDom);
        myMonthChart.setOption(this.getMonthChartOptions(monthData), true);

        // 初始化新的 ECharts 实例
        myAccrueChart = echarts.init(accrueChartDom);
        myAccrueChart.setOption(this.getAccrueChartOptions(accrueData), true);
      }
    },

    getMonthChartOptions(data){
      return {
        title: {
          left: 'left',
          text: '单月KPI'
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['实际','基本任务','高级任务']
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: data.yName,
          },
        ],
        series: data.seriesData
      }
    },
    getAccrueChartOptions(data){
      return {
        title: {
          left: 'left',
          text: '累积KPI'
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['实际', '基本任务', '高级任务']
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: data.yName,
          }
        ],
        series: data.seriesData
      }
    }

  }
}
</script>

<style scoped>

.dimension_amount{
  width: 150px;
  line-height: 30px;
  margin-left: 20px;
  border: 1px #cccccc solid;
  text-align: center;
  cursor: pointer
}

.dimension_sales{
  width: 150px;
  line-height: 30px;
  border: 1px #cccccc solid;
  border-left: none;
  text-align: center;
  cursor: pointer
}

</style>